(() => {
  // Ändert das Datumsformat der Bewertungen von MM/DD/YYYY in DD.MM.YYYY
  function convertReviewWidgetDates(root = document) {
    root.querySelectorAll("span.jm-text").forEach((span) => {
      const text = span.textContent.trim();

      const match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);

      if (!match) return;

      const [, month, day, year] = match;

      span.textContent = `${day.padStart(2, "0")}.${month.padStart(2, "0")}.${year}`;
      span.dataset.dateConverted = "true";
    });
  }
  // Liest die numerische Produktbewertung aus und fügt diese vor der Sternebewertung ein
  function insertReviewScoreText(root = document) {
    root.querySelectorAll("span.jdgm-prev-badge__stars").forEach((starsSpan) => {
      if (starsSpan.dataset.scoreTextInserted === "true") return;

      const score = starsSpan.dataset.score;

      if (!score) return;

      const formattedScore = Number(score).toFixed(1);

      const scoreText = document.createElement("p");
      scoreText.className = "jdgm-custom-score-text";
      scoreText.textContent = formattedScore;

      starsSpan.parentNode.insertBefore(scoreText, starsSpan);

      starsSpan.dataset.scoreTextInserted = "true";
    });
  }

  function runReviewWidgetCustomizations(root = document) {
    convertReviewWidgetDates(root);
    insertReviewScoreText(root);
  }

  document.addEventListener("DOMContentLoaded", () => {
    runReviewWidgetCustomizations();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            runReviewWidgetCustomizations(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();